const BKK_POSTCODES = [
  '10100',
  '10110',
  '10120',
  '10140',
  '10150',
  '10160',
  '10170',
  '10200',
  '10210',
  '10220',
  '10230',
  '10240',
  '10250',
  '10260',
  '10300',
  '10310',
  '10330',
  '10400',
  '10500',
  '10510',
  '10520',
  '10530',
  '10600',
  '10900',
  '10700',
  '10800',
  '10900'
]

// eslint-disable-next-line import/prefer-default-export
export const isBkkZipCode = (postcode) => BKK_POSTCODES.includes(postcode)
